import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { getTariffPrice } from '../../../../../crud/orders.crud';

export type TPriceRoute = {
  id: number;
  name: string;
  cost: number;
};

export const useGetPriceRoute = (setPrice?: (price: TPriceRoute[]) => void) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingPrice, setLoading] = useState(false);
  const [prices, setPrices] = useState<TPriceRoute[]>([]);
  const fm = useFormatMessage();

  const fetchPriceTariff = async (data: {
    length: number;
    time: number;
    province1?: string;
    province2?: string;
  }) => {
    setLoading(true);
    getTariffPrice(data)
      .then(res => {
        setPrices(res.data.data);
        setPrice?.(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clear = () => setPrices([]);

  return { fetchPriceTariff, loadingPrice, prices, clear };
};
